<template>
  <div
    class="d-flex align-center gap-120 radius-small pa-4 dataCount"
    data-testid="reporting-unit-count"
  >
    <template v-if="loading">
      <v-skeleton-loader
        type="text"
        width="150"
        height="15"
        class="mx-auto"
        data-testid="reporting-unit-count__label-skeleton"
      ></v-skeleton-loader>
      <v-skeleton-loader
        type="text"
        width="60"
        height="15"
        class="mx-auto"
        data-testid="reporting-unit-count__value-skeleton"
      ></v-skeleton-loader>
    </template>
    <template v-else-if="count > 0">
      <h6
        class="font-weight-medium"
        data-testid="reporting-unit-count__label"
      >
        {{ $nova.labelsName('my_reporting_units_page', 'unit_count_label', 'Reporting Unit Count')}}
      </h6>
      <h3
        class="font-weight-medium"
        data-testid="reporting-unit-count__value"
      >
        {{ count }}
      </h3>
    </template>
  </div>
</template>

<script>
/**
 * ReportingUnitCount Component
 * Displays the count of reporting units with loading state support.
 */
export default {
  name: 'ReportingUnitCount',
  props: {
    count: {
      type: Number,
      required: true,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageName: 'my_reporting_units_page',
    };
  },
};
</script>

<style scoped>
.dataCount {
  width: fit-content;
  border: 1px solid var(--color-status-card-border);
  height: 44px;
  border-radius: 8px;
  border: 1px solid #B2B2B4;
  background: #F7F7F7;
}
</style>
